import * as React from "react";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import { mobileScreenBottomNavigationStyles } from "./styles";
import { useNavigate } from "react-router-dom";
import { BORDER_COLOR } from "../../theme";
import { UserDetailsContext } from "../../contexts";

export const MobileScreenBottomNavigation: React.FC = () => {
  const [currentPage, setCurrentPage] = React.useState("Tracks");
  const navigate = useNavigate();
  const { userName } = React.useContext(UserDetailsContext);

  React.useEffect(() => {
    if (window.location.href.includes("explore")) {
      setCurrentPage("Explore");
    } else if (window.location.href.includes("my-tracks")) {
      setCurrentPage("Hub");
    } else if (window.location.href.includes("profile")) {
      setCurrentPage("Profile");
    } else if (window.location.href.includes("messages")) {
      setCurrentPage("Messages");
    }
  }, []);

  return (
    <Box sx={mobileScreenBottomNavigationStyles.mainContainer}>
      <Box
        onClick={() => navigate("/my-tracks")}
        sx={mobileScreenBottomNavigationStyles.tabContainer}
      >
        <Box
          sx={{
            ...mobileScreenBottomNavigationStyles.imageContainer,
            backgroundColor:
              currentPage === "Hub" ? BORDER_COLOR : "transparent",
          }}
        >
          <img
            style={{
              padding: "5px",
              filter:
                currentPage === "Hub" ? "contrast(100%)" : "contrast(30%)",
            }}
            src="/assets/icons/TracksPageIcons/music-note-02.svg"
            alt="icon"
          />
        </Box>
        <Typography sx={mobileScreenBottomNavigationStyles.typography}>
          Hub
        </Typography>
      </Box>
      <Box
        onClick={() => navigate("/explore")}
        sx={mobileScreenBottomNavigationStyles.tabContainer}
      >
        <Box
          sx={{
            ...mobileScreenBottomNavigationStyles.imageContainer,
            backgroundColor:
              currentPage === "Explore" ? BORDER_COLOR : "transparent",
          }}
        >
          <img
            style={{
              padding: "5px",
              filter:
                currentPage === "Explore" ? "contrast(1000%)" : "contrast(30%)",
            }}
            src="/assets/icons/TracksPageIcons/compass-03.svg"
            alt="icon"
          />
        </Box>
        <Typography sx={mobileScreenBottomNavigationStyles.typography}>
          Explore
        </Typography>
      </Box>
      <Box
        onClick={() => navigate("/messages")}
        sx={mobileScreenBottomNavigationStyles.tabContainer}
      >
        <Box
          sx={{
            ...mobileScreenBottomNavigationStyles.imageContainer,
            backgroundColor:
              currentPage === "Messages" ? BORDER_COLOR : "transparent",
          }}
        >
          <img
            style={{
              padding: "5px",
              filter:
                currentPage === "Messages"
                  ? "contrast(1000%)"
                  : "contrast(30%)",
            }}
            src="/assets/icons/TracksPageIcons/message-chat-circle.svg"
            alt="icon"
          />
        </Box>
        <Typography sx={mobileScreenBottomNavigationStyles.typography}>
          Messages
        </Typography>
      </Box>
      <Box
        onClick={() => navigate("/user-profile/" + userName)}
        sx={mobileScreenBottomNavigationStyles.tabContainer}
      >
        <Box
          sx={{
            ...mobileScreenBottomNavigationStyles.imageContainer,
            backgroundColor:
              currentPage === "Profile" ? BORDER_COLOR : "transparent",
          }}
        >
          <AccountCircleOutlinedIcon
            sx={{
              fontSize: "25px",
              filter:
                currentPage === "Profile" ? "contrast(1000%)" : "contrast(30%)",
            }}
          />
        </Box>
        <Typography sx={mobileScreenBottomNavigationStyles.typography}>
          Profile
        </Typography>
      </Box>
    </Box>
  );
};
